
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transfer/troubleshooting",
      function () {
        return require("private-next-pages/docs/transfer/troubleshooting.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transfer/troubleshooting"])
      });
    }
  